import { render, staticRenderFns } from "./wozhifuSsoLogin.vue?vue&type=template&id=291a8761&scoped=true"
import script from "./wozhifuSsoLogin.vue?vue&type=script&lang=js"
export * from "./wozhifuSsoLogin.vue?vue&type=script&lang=js"
import style0 from "./wozhifuSsoLogin.vue?vue&type=style&index=0&id=291a8761&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291a8761",
  null
  
)

export default component.exports